import React, { Fragment } from 'react'
import { Bold, Slate } from 'components/Text'
import { CircleCancel } from 'components/Icon'
import Tooltip from 'components/Tooltip'
import { Form, spacer, color, SwitchInput } from 'stylist'
import { getQualTranslations } from 'utils/api'
import styled from '@emotion/styled'
import MultiSelect from './MultiSelect'
import Age from './Age'
import ZipCode from './ZipCode'
import size from 'lodash/size'

const OffWhite = styled.div`
  padding: ${spacer(3)} ${spacer(3)};
  background-color: ${color('offWhite')};
`

const TitleWrapper = styled(OffWhite)`
  display: flex;
  flex: 90% 10%;
  text-align: left;
  line-height: ${spacer(4)};
`

const TitleText = styled(OffWhite)`
  display: flex;
  flex: 1;
  text-align: left;
  line-height: ${spacer(4)};
`

const TopTitle = styled(TitleWrapper)`
  border-top-left-radius: ${spacer(1)};
  border-top-right-radius: ${spacer(1)};
  margin-bottom: ${spacer(1)};
`

const Grow = styled.span`
  flex: 1;
`

const Remove = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  float: right;

  &:hover ${CircleCancel} {
    background-color: ${color('red')};
  }
`

const QualTitle = ({ title, onRemove }) => (
  <TopTitle>
    <Grow>
      <Bold>
        <Slate>{title}</Slate>
      </Bold>
    </Grow>
    <Remove onClick={onRemove}>
      <CircleCancel size="xxs" />
      Remove Target
    </Remove>
  </TopTitle>
)

/**
 * Wrapper component for translation toggle switch
 */
class ToggleTranslation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false
    }
  }

  toggle() {
    if (!this.props.disabled) {
      this.setState({ checked: !this.state.checked })
      this.props.onToggle()
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.disabled !== this.props.disabled) {
      this.setState({ checked: false })
    }
  }

  render() {
    const toggle = (
      <div onClick={() => this.toggle()} id="translate-qual">
        <SwitchInput
          label="Translate"
          disabled={this.props.disabled}
          checked={this.state.checked}
          onChange={e => this.setState({ checked: e.target.checked })}
        />
      </div>
    )

    return this.props.disabled && !this.props.locale.startsWith('en_') ? (
      <Tooltip contents="No translation available">{toggle}</Tooltip>
    ) : (
      toggle
    )
  }
}

/**
 * Displays the Qualification Box to select answers/set quotas
 * @param {String} qualID id of qual e.g. 'gender'
 * @param {Object} qualData data from API of `qualID`
 * @param {Function} onRemove handler for remove event
 */
class QualSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      translationsEnabled: false,
      translationsToggleDisabled: this.props.locale.startsWith('en_'),
      translations: {}
    }
  }

  getTranslatedOptions() {
    if (this.state.translationsEnabled) {
      const translation = this.state.translations[this.props.qualID]
      return translation && translation.options
    }

    return []
  }

  getTranslatedTitle() {
    const translation = this.state.translations[this.props.qualID]
    return translation && translation.text
  }

  loadTranslations(qualIDs) {
    getQualTranslations(this.props.locale, 'en_US', qualIDs).then(res => {
      this.setState({ translations: res.data })

      if (!size(res.data)) {
        this.setState({
          translationsToggleDisabled: true,
          translationsEnabled: false
        })
      }
    })
  }

  toggleTranslations() {
    this.setState(
      { translationsEnabled: !this.state.translationsEnabled },
      () => {
        if (this.state.translationsEnabled && !size(this.state.translations)) {
          this.loadTranslations(this.props.qualIDs)
        }
      }
    )
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.qualIDs !== this.props.qualIDs &&
      (this.state.translationsEnabled || size(this.state.translations))
    ) {
      this.loadTranslations(newProps.qualIDs)
    }
  }

  render() {
    const { qualID, qualData, onInit, onRemove, locale } = this.props
    const translatedOptions = this.getTranslatedOptions()
    const translatedTitle = this.getTranslatedTitle()
    const titleText =
      this.state.translationsEnabled && translatedTitle
        ? translatedTitle
        : this.props.qualData.text
    return (
      <Form.Field
        name={`questions.${qualID}`}
        render={({ value: formQual, setValue: setQual }) => (
          <Fragment>
            <QualTitle title={qualData.title} onRemove={onRemove} />
            <TitleWrapper>
              <TitleText className="title-text">{titleText}</TitleText>
              <ToggleTranslation
                qualId={qualID}
                locale={locale}
                onToggle={() => this.toggleTranslations()}
                disabled={this.state.translationsToggleDisabled}
              />
            </TitleWrapper>
            <OffWhite>
              {qualID === 'age' ? (
                <Age ranges={formQual} setRanges={setQual} />
              ) : qualID === 'zip' ? (
                <ZipCode
                  zips={formQual}
                  setZips={setQual}
                  onFileUpload={zips => onInit('zip', zips)}
                />
              ) : (
                <MultiSelect
                  name={qualID}
                  options={qualData.options}
                  translatedOptions={translatedOptions}
                  selected={formQual}
                  setSelected={setQual}
                />
              )}
            </OffWhite>
          </Fragment>
        )}
      />
    )
  }
}

export default QualSettings



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QualSettings.js